import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatStepper } from '@angular/material/stepper';
import { io } from 'socket.io-client';
import { SetupCompleteComponent } from '../setup-complete/setup-complete.component';
import { SetupSteps } from 'src/app/setupSteps';

export interface PowershellFlow {
  stage: string;
  status: string;
}
const POWERSHELL_FLOW: PowershellFlow[] = [
  { stage: 'Authenticating', status: "P" },
  { stage: 'Verifying domain', status: "W" },
  { stage: 'Adding connectors', status: "W" },
  { stage: 'Adding mail-flow rules', status: "W" },
  { stage: 'Finishing up', status: "W" },
];

@Component({
  selector: 'app-delete-setup',
  templateUrl: './delete-setup.component.html',
  styleUrls: ['./delete-setup.component.css']
})
export class DeleteSetupComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private globals: Globals,
    private setupSteps: SetupSteps,
    private http: HttpClient,
    private router: Router,
    public route: ActivatedRoute,

    private clipboard: Clipboard,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }
  @ViewChild('setupStepper') public myStepper: MatStepper;
  @ViewChild('microsoftStepper') public microsoftStepper: MatStepper;

  autoDisabled = false;//True to grey out autosetup button
  powershellRules = {
    connect: '',
    outboundConnector: '',
    inboundConnector: '',
    identifyRule: '',
    replyRule: '',
    allowRule: ''
  }
  inputDomain = "";
  loading = false;
  displayedColumns: string[] = ['stage', 'status'];
  dataSource;
  msAuthToken: "";
  domain:"";
  processing = false;
  personalRule = false;
  isTLS = false
  link: string;
  microsoft=null;
  onTabChanged($event) {
    if ($event.selectedIndex === 0) {
      this.dataSource = [
        { stage: 'Authenticating', status: "P" },
        { stage: 'Verifying domain', status: "W" },
        { stage: 'Removing mail-flow rules', status: "W" },
        { stage: 'Removing connectors', status: "W" },
        { stage: 'Finishing up', status: "W" },
      ];
    } 
  }
  ngOnInit(): void {
    this.dataSource = POWERSHELL_FLOW;
    this.route.queryParams.subscribe(async params => {
      if (params['1']) {
        this.link = params['1']
      } else if (this.globals.getCompanyId()) {
        let param = new HttpParams()
        param = param.append('AuthToken', await this.globals.getAuthToken())
        param = param.append('UserName', this.globals.getSystemUserName())
        param = param.append('CompanyId', this.globals.getCompanyId())
        this.http.get<any>(this.globals.getApiUrl() + 'api/getSPMailCompanyInfo.php', { params: param }).subscribe({
          next: data => {
            this.domain=data.DomainList[0]
            let domainp = new FormData;
            domainp.append('domain', this.domain);
            this.http.post<any>(this.globals.getServicesUrl() + "dns/mxCheck", domainp).subscribe({
              next: data => {
                if (data.type == 'microsoft365') {
                  this.microsoft=true; 

                } else if (data.type == 'google') {
                  this.microsoft=false; 

                } else if (data.type == 'other') {
                  this.microsoft=null; 

                }
              },
              error: error => {
                this._snackBar.open(error.error.ErrorMsg, "OK", { duration: 5000 });
              }
            });
            this.powershellRules = {
              connect: 'Connect-ExchangeOnline -Device -DelegatedOrganization ' + this.domain,
              identifyRule: 'Remove-TransportRule "Identify messages to send via StayPrivate"',
              replyRule: 'Remove-TransportRule "Send secure replies to StayPrivate"',
              allowRule: 'Remove-TransportRule "StayPrivate Allow"',
              outboundConnector: 'Remove-OutboundConnector "Send to StayPrivate"',
              inboundConnector: 'Remove-InboundConnector "Receive from StayPrivate"'
            }
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
      }
    });


  }
  setupCompany() {
    this.myStepper.selectedIndex = 4

    if (this.domain) {
      const socket = io(this.globals.getServicesUrl(), {
        query: {
          "Domain": this.domain,
          "CompanyId": this.globals.getCompanyId(),
          "Keyword": "#private",
          "Delete": "Y",
          "Personal": "N",
          "StandAlone": "Y",
          "NewVersion": "Y",
          "SignKeyword": "#sign"
        }
      });
      this.loading = true;
      socket.on('authToken', (data) => {
        this.msAuthToken = data;
        this.loading = false;
      })
      let fetchedDomains;
      socket.on('domains', (data) => {
        fetchedDomains = data;

      })
      socket.on('message', (data) => {
        if (data === "Authenticated") { this.dataSource[0].status = "S"; this.dataSource[1].status = "P" }
        if (data === "Domain verified") { this.dataSource[1].status = "S"; this.dataSource[2].status = "P" }
        if (data === "Removed Identify Personal Recipients to send via StayPrivate") { this.dataSource[2].status = "S"; this.dataSource[3].status = "P" }
        if (data === "Removed Receive from StayPrivate") { this.dataSource[3].status = "S"; this.dataSource[4].status = "P" }
        if (data === "Finished Up") { this.dataSource[4].status = "S"; this.finish() }
      })
      socket.on('error', (data) => {
        if (data === "Error authenticating") {
          this.dataSource[0].status = "F"
          socket.disconnect()
          socket.close()
          this.myStepper.selectedIndex = 0
          this._snackBar.open("There was an issue authenticating your domain. Please contact support@stayprivate.com.", "OK", { duration: 3000 });

        }
        if (data === "Domain not found in server") {
          this.dataSource[0].status = "F"
          socket.disconnect()
          socket.close()
          this.myStepper.selectedIndex = 0
          this._snackBar.open("Your domain was not found. Please try again or contact support@stayprivate.com.", "OK", { duration: 3000 });
        }
        if (data === "Error adding connectors") { this.dataSource[2].status = "F"; this.dataSource[3].status = "P" }
        if (data === "Error adding rules") { this.dataSource[3].status = "F"; this.dataSource[4].status = "P" }
        if (data === "Session Expired") {
          this.dataSource[0].status = "F"
          socket.disconnect()
          socket.close()
          this.myStepper.selectedIndex = 0
          this._snackBar.open("Your session has timed out. Please try again.", "OK", { duration: 3000 });
        }
      })
      socket.on('json', (data) => {
      })
      socket.on("disconnect", (reason) => {
        socket.disconnect()
        socket.close()
        console.log('disconnect', reason)
      });

    }
  }
  copy(copyVariable) {
    this.clipboard.copy(copyVariable);
    this._snackBar.open("Copied!", "OK", { duration: 3000 });
  }
  finish() {

  }
  openAuth() {
    this.processing = true;
    window.open("https://microsoft.com/devicelogin", "", "top=100,left=100,width=500,height=600");
  }

}
